import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const TitleBar = styled.div`
  display: flex;
  align-items: center;
  padding: ${theme.spacing.xm};
  background-color: ${theme.colors.neutral.white};
  gap: ${theme.spacing.xs};
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${theme.colors.neutral.white};
  padding: ${theme.spacing.sm} ${theme.spacing.xm};
  border-radius: ${theme.shapes.borderRadius.xm};
  border: 1px solid ${theme.colors.neutral.softer};
  gap: ${theme.spacing.xm};
`

export const TabsWrapper = styled.div`
  width: 100%;

  #action-tabs-wrap {
    margin: 0;
    padding: 0;

    button {
      font-size: ${theme.typography.sizes.xs};
      padding: ${theme.spacing.sm};
      font-family: ${theme.typography.family.primary};
      font-weight: ${theme.typography.weight.sm};
    }
  }
`

export const TableWrapper = styled.div`
  display: grid;
  width: 100%;
  overflow-x: auto;
  gap: ${theme.spacing.xm};
`

export const IconContainer = styled.div`
  display: flex;
  width: ${theme.sizes.ion.global.x72};
  height: ${theme.sizes.ion.global.x72};
  background-color: ${theme.colors.ion.primary.softer};
  justify-content: center;
  align-items: center;
  border-radius: ${theme.radius.buttons};
`
